export default "__VITE_ASSET__CHU24UNS__"